import { Component } from '@angular/core';

import { MAIN } from './shared/constant/main';

@Component({
    selector: 'app-main',
    template: require('./app.component.html')
})
export class AppComponent {
    public appBrand: string;

    constructor() {
        this.appBrand = MAIN.APP.BRAND;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src?loader=system&genDir=src&aot=false!./~/tslint-loader!./src/app/app.component.ts